/**
 * Layout component that queries for data
 * with Gatsby's StaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import Helmet from "react-helmet"
import "./layout.scss"

const Layout = ({
  children,
  title,
  id,
  maxWidth,
  textAlign,
}) => (
  <div className="mx-auto" style={{ maxWidth, textAlign }}>
    <Helmet>
      <title>{ title }</title>
      {id && <meta name="uuid" content={id} />}
    </Helmet>
    <main>{children}</main>
  </div>
);

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  maxWidth: PropTypes.number,
  textAlign: PropTypes.string,
};

Layout.defaultProps = {
  maxWidth: 540,
  textAlign: 'center',
};

export default Layout;